import "./ClubPage.css";
import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const ClubPage = () => {
  return (
    <>
    <Navbar/>
      <div  class="mainCont" style={{ marginLeft: "5vh"}}>
        <h1 id="hero" className="sai">BUILD YOUR NETWORK</h1>
        <h2 className="helo">
          A student club, is an organization or group formed by students with
          common interests, goals, or activities. They provide students with
          opportunities to engage in extracurricular activities outside of their
          regular academic curriculum.
        </h2>
        <br/>
        <a href="https://drive.google.com/file/d/12u3kzxFmB_VCA6FyxR_827DyUOSQu1Yy/view?usp=sharing" class="faculty">MEET OUR ESTEEMED FACULTY</a>
        <h2 className="sai71" style={{ color: "aqua" }}>
          Faculty Co-ordinators:
          <b className="sai6"> SUKRUTHA C B, KAVYA T C</b>
        </h2>
        <h2 className="sai7" style={{ color: "aqua" }}>
          Student Co-ordinators:
          <b className="sai6"> LALITHA SHREE C P, SATWIK G VAIDYA  </b>
        </h2>
        <br />
        <hr />
        <br />
        <div>
          <center>
            <h2 className="sai2" style={{ color: "aqua" }}>
              COMMUNITY SERVICE CLUB
            </h2>
          </center>
          <img class="ff"
            src="Community_Service.png"
            style={{ float: "left" }}
            alt="Community Service Club"
          />

          <h2 className="sai3">OBJECTIVES:</h2>
          <p>
            ➤ Our foundation is rooted in service-oriented principles, driven by an unwavering commitment to improving lives and communities through selfless efforts.
          </p>
          <p>
            ➤We aim to create a profound societal impact by fostering empathy, compassion, leadership qualities, communication skills, team building, and a resolute willingness to help, thereby nurturing holistic personal development and positive social change.
          </p>

          <h2 className="sai4" style={{ color: "rgb(255, 255, 255)" }}>
            Co-Ordinators: <b className="sai5">BHUMIKA C P, UTTAM JITENDRA</b>
          </h2>
          <br /><br/><br/><br/><br/>
          <br />
          <br />
          <hr />
          <center>
          <br />
            <h2 className="sai2" style={{ color: "aqua" }}>
              CULTURAL CLUB
            </h2>
          </center>
          <img class="ff"
            src="Cultural.png"
            style={{ float: "left", marginRight: "5vh" }}
            alt="Community Service Club"
          />

          <h2 className="sai3">OBJECTIVES:</h2>
          <p>
            ➤ Enhancing individuals artistic, cultural aspects to open doors to
            self-expression, creativity, and a deeper appreciation for diverse
            forms of art.
          </p>
          <p>
            ➤ Providing supportive environments, efforts can be made to vanquish
            stage fear in students, empowering them to express themselves
            confidently and authentically.
          </p>
          
          <h2 className="sai4" style={{ color: "rgb(255, 255, 255)" }}>
            Co-Ordinators:<b className="sai5"> CHIRAG C, TEJASWINI D</b>
          </h2>
          <br /><br/><br/><br/><br/><br/>
          <hr />
          <center>
          <br />
            <h2 className="sai2" style={{ color: "aqua" }}>
              TECHNICAL DESIGN, MARKETING AND
              <br /> NEWSLETTER
            </h2>
          </center>
          <img
            src="Design.png" class="ff"
            style={{ float: "left", marginRight: "5vh" }}
            alt="Community Service Club"
          />

          <h2 className="sai3">OBJECTIVES:</h2>
          <p>
            ➤ The design and marketing college club aims to provide students
            with a platform to enhance their skills in design and marketing
            through workshops and training sessions.
          </p>
          <p>
            ➤ The club seeks to foster networking and collaboration among its
            members, offering real-world project opportunities to gain practical
            experience
          </p>

          <h2 className="sai4" style={{ color: "rgb(255, 255, 255)" }}>
            Co-Ordinators:
            <b className="sai5">
              {" "}
              HARINI SRI K,NANDAN K, ESHAALAKSHMI,NIGHAM B GHAT
            </b>
          </h2>
          <br /><br/><br/><br/><br/><br/>
          <hr />
          <center>
          <br />
            <h2 className="sai2" style={{ color: "aqua" }}>
              WEB AND MOBILE APP DEVELOPMENT
            </h2>
          </center>
          <img class="ff"
            src="1.png"
            style={{ float: "left", marginRight: "5vh" }}
            alt="Community Service Club"
          />

          <h2 className="sai3">OBJECTIVES:</h2>
          <p>
            ➤The club encompasses web development (both frontend and backend) as well as mobile app development, forming the foundation for conducting various activities and projects.
          </p>
          <p>
            ➤The club's activities will span a range of engaging formats including competitions, games, and quizzes. One such competition involves creatively presenting textual content and images in an appealing manner. Additionally, participants will be challenged to reconstruct existing websites from scratch based on provided screenshots.
          </p>

          <h2 className="sai4" style={{ color: "rgb(255, 255, 255)" }}>
            Co-Ordinators: <b className="sai5">VIVEK N, SHREYA GORE</b>
          </h2>
          <br />
          <br />
          <br/><br/><br/>
          <hr />
          <center>
          <br />
            <h2 className="sai2" style={{ color: "aqua" }}>
              ARTIFICIAL INTELLEGENCE AND MACHINE LEARNING
            </h2>
          </center>
          <img class="ff"
            src="aiml.png"
            style={{ float: "left", marginRight: "5vh" }}
            alt="Community Service Club"
          />

          <h2 className="sai3">OBJECTIVES:</h2>
          <p>
            ➤ The primary objective of an AIML club is to provide a platform for
            students to learn about artificial intelligence and machine learning
            and facilitates hands-on projects and coding exercises to real-world
            problems.
          </p>
          <p>
            ➤ The primary objective of an AIML club is to provide a platform for
            students to learn about artificial intelligence and machine learning
            and facilitates hands-on projects and coding exercises to real-world
            problems.
          </p>

          <h2 className="sai4" style={{ color: "rgb(255, 255, 255)" }}>
            Co-Ordinators:<b className="sai5"> KHUSHI CHHETRI, KRITI DIWAKAR</b>
          </h2>
          <br />
          <br /><br/><br/><br/>
          <hr />
          <center>
          <br />
            <h2 className="sai2" style={{ color: "aqua" }}>
              INTERNET OF THINGS
            </h2>
          </center>
          <img class="ff"
            src="IOT.png"
            style={{ float: "left", marginRight: "5vh" }}
            alt="Community Service Club"
          />

          <h2 className="sai3">OBJECTIVES:</h2>
          <p>
            ➤ An IoT club aim to educate its members and the wider community
            about the concepts, technologies, and applications of IoT.
          </p>
          <p>
            ➤ It offers hands-on projects, hackathons, and coding sessions to
            enhance members' technical capabilities.
          </p>

          <h2 className="sai4" style={{ color: "rgb(255, 255, 255)" }}>
            Co-Ordinators: <b className="sai5">ANKITHA V, RACHANA DEEPAK</b>
          </h2>
          <br />
          <br /><br/><br/><br/><br/><br/><br/>
          <hr />
          <center>
          <br />
            <h2 className="sai2" style={{ color: "aqua" }}>
              COMPETITIVE CODING AND HACKATHONS
            </h2>
          </center>
          <img
            src="compCode.png" class="ff"
            style={{ float: "left", marginRight: "5vh" }}
            alt="Community Service Club"
          />

          <h2 className="sai3">OBJECTIVES:</h2>
          <p>
            ➤The primary goal is to familiarize individuals with the realm of competitive programming, facilitating an understanding of its dynamics and intricacies.
          </p>
          <p>
            ➤The club aims to cultivate a culture of innovative thinking and effective problem-solving, enabling members to address significant challenges in their daily lives. It also focuses on collectively improving analytical skills, fostering a coding culture, and promoting an appreciation for the real-world impact of code efficiency.
          </p>

          <h2 className="sai4" style={{ color: "rgb(255, 255, 255)" }}>
            Co-Ordinators:{" "}
            <b className="sai5">AYAAN KUMAR, BHARGAVA S B, NIKHIL RAJ GUPTA</b>
          </h2>
          <br /><br/><br/><br/>
          <br/>
          <br />
          <hr />
          <center>
          <br />
            <h2 className="sai2" style={{ color: "aqua" }}>
              CYBER SECURITY
            </h2>
          </center>
          <img class="ff"
            src="Cyber.png"
            style={{ float: "left", marginRight: "5vh" }}
            alt="Community Service Club"
          />

          <h2 className="sai3">OBJECTIVES:</h2>
          <p>
            ➤ The objective is to get basic knowledge on AIML and elevate it
            through projects and quizzes. There will be an intro session and
            mini projects to apply it in the real world.
          </p>
          <p>
            ➤ participating in various competitions, paper publication and
            discussing, learning about and working on topics related to
            artificial intelligence and machine learning.
          </p>

          <h2 className="sai4" style={{ color: "rgb(255, 255, 255)" }}>
            Co-Ordinators:<b className="sai5"> FARHAN BEG</b>
          </h2>
          <br /><br/><br/><br/>
          <hr />
          <center>
          <br />
            <h2 className="sai2" style={{ color: "aqua" }}>
              SPORTS CLUB
            </h2>
          </center>
          <img
            src="Sports.png" class="ff"
            style={{ float: "left", marginRight: "5vh" }}
            alt="Community Service Club"
          />

          <h2 className="sai3">OBJECTIVES:</h2>
          <p>
            ➤ Sports club aim to encourage and facilitate regular physical
            activity and provide straining programs, coaching, and practice
            sessions to help individuals improve their abilities in a specific
            sport or discipline.
          </p>
          <p>
            ➤ Club participate in competitive leagues, tournaments, and events ,
            main objective is to foster a competitive spirit among members, help
            them set goals, and provide opportunities for them to achieve
            success and recognition in their chosen sport.
          </p>

          <h2 className="sai4" style={{ color: "rgb(255, 255, 255)" }}>
            Co-Ordinators:<b className="sai5"> AMOG PATEL D K, RAJENDRA H P</b>
          </h2>
          <br />
          <br /><br/><br/><br/>
          <hr />
          <center>
          <br />
            <h2 className="sai2" style={{ color: "aqua" }}>
              LITERARY CLUB
            </h2>
          </center>
          <img
            src="literary.png" class="ff"
            style={{ float: "left", marginRight: "5vh" }}
            alt="Community Service Club"
          />

          <h2 className="sai3">OBJECTIVES:</h2>
          <p>
            ➤ Collaborating authors to discuss stories and poems, bringing
            together their unique perspectives to captivate readers.
          </p>
          <p>
            ➤ The verse slam provides a stage where spoken word and performance
            art intertwine, creating an immersive and unforgettable experience
            for artists and audience alike.
          </p>

          <h2 className="sai4" style={{ color: "rgb(255, 255, 255)" }}>
            Co-Ordinators:<b className="sai5"> ANANYA S B, SHASHTISHREE M A</b>
          </h2>
          <br />
          <br />
        
        </div>
      </div>
      <div className="footClub">
      <Footer/>
      </div>
    </>
  );
};

export default ClubPage;
